export default __webpack_public_path__ + "static/media/dog3.a12041bc.JPG";